import React from 'react';
import heroImage from '../assets/hero.jpg';

interface HeroProps {
  className?: string;
}

const Hero: React.FC<HeroProps> = ({ className }) => {
  return (
    <div className={`hero-background ${className || ''}`}>
      <div className="hero-image-wrapper">
        <img
          src={heroImage}
          alt="Hero background"
          className="hero-background-image"
        />
        <div className="hero-blur-overlay"></div>
        <div className="hero-gradient-overlay"></div>
      </div>
    </div>
  );
};

export default Hero; 